import GanttColumnProps from './Columns'

let KendoGanttColumn = {
    name: 'kendo-gantt-column',
    render () {
        return null
    },
    mixins: [GanttColumnProps]
}

export default KendoGanttColumn


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGanttColumn/index.js